import React, { useState, useEffect, useRef, useCallback } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import {logout} from '../utils/authUtils';
import { getCompanyProfileDDList, getDivisionDDList, getDepartmentDDList, getDivisionAdditionalList }  from '../services/user.service';
import * as CryptoJS from 'crypto-js';
import '../Notificationbell.css';

function CompDivDepFilter() {
    const [companies, setCompanies] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [otherDivisions, setOtherDivisions] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [searchCompany, setSearchCompany] = useState('');
    const [selectedCompanyId, setSelectedCompanyId] =useState(0);
    const [selectedCompany, setSelectedCompany] = useState(sessionStorage.getItem("CurrentCompanyName") || 'Select Company');
    const [searchDivision, setSearchDivision] = useState('');
    const [selectedDivisionId, setSelectedDivisionId] = useState(0)
    const [selectedDivision, setSelectedDivision] = useState(sessionStorage.getItem("CurrentDivisionName") || 'Select Branch');
    const [searchDepartment, setSearchDepartment] = useState('');
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(0);
    const [selectedDepartment, setSelectedDepartment] = useState(sessionStorage.getItem("CurrentDepartmentName") || 'Select Department');
    
    const [filteropen, setFilterOpen]       = useState(false);
    const [filterLoading, setFilterLoading]             = useState(false);

    // Accordion state: which sections are expanded
    const [expanded, setExpanded] = useState({ today: true, last7: true, last814: true });

    const panelFilRef = useRef(null);
    const filterRef  = useRef(null);
    const handleLogout = (event) => {
        event.preventDefault();
        logout();
    };
    const handleSearchCompany = (event) => {
        setSearchCompany(event.target.value);
    };
    const handleSearchDivision = (event) => {
        setSearchDivision(event.target.value);
    };
    const handleSearchDepartment = (event) => {
        setSearchDepartment(event.target.value);
    };
    const handleSelectCompany = (company) => {
        const { company_id, company_name } = company;
        sessionStorage.setItem('CurrentCompanyId', parseInt(company_id));
        sessionStorage.setItem('LoggedInCompanyId', parseInt(company_id));
        sessionStorage.setItem('LoggedInDivisionId', '0');
        sessionStorage.setItem('LoggedInOtherDivisionIds', '');
        sessionStorage.setItem('LoggedInDepartmentId', '0');
        sessionStorage.setItem('CurrentDivisionId', '0');
        sessionStorage.setItem('CurrentDepartmentId', '0');
        sessionStorage.setItem('CurrentCompanyName', company_name); // Store the selected company name
        setSelectedCompanyId(company_id); // Update state
        setSelectedCompany(company_name); // Update state
        setSelectedDepartment(' All Department');
        setSelectedDivision(' All Branch');
        sessionStorage.setItem('CurrentDivisionName', '');
        sessionStorage.setItem('CurrentDepartmentName', '');
        fetchCurrentCompanyList();
        fetchCurrentDivisionList();
        fetchCurrentDepartmentList();
        sessionStorage.setItem('applyCompanyFilter', 'Yes');
        //window.location.reload(false);
    };
    
    const handleSelectDepartment = (department) => {
        const { id, department_name } = department;
        //sessionStorage.setItem('CurrentCompanyId', sessionStorage.getItem('LoggedInCompanyId') );
        //sessionStorage.setItem('CurrentDivisionId', sessionStorage.getItem('LoggedInDivisionId')); 
        
        sessionStorage.setItem('CurrentDepartmentId', parseInt(id)); 
        sessionStorage.setItem('LoggedInDepartmentId', parseInt(id));
        sessionStorage.setItem('CurrentDepartmentName', department_name); // Store the selected company name
        setSelectedDepartmentId(id);
        setSelectedDepartment(department_name); // Update state
        fetchCurrentDepartmentList();
        sessionStorage.setItem('applyDepartmentFilter', 'Yes');
        if(sessionStorage.getItem('LoggedInDivisionId')==0){ 
            sessionStorage.setItem('LoggedInDivisionId', '0');
            sessionStorage.setItem('CurrentDivisionId', '0');
            setSelectedDivision(' All Branch');
            sessionStorage.setItem('CurrentDivisionName', '');
            fetchCurrentDivisionList();
        }
        
        //window.location.reload(false);
    };
    const handleSelectDivision = (division) => {
        console.log(division);
        const { id, division_name } = division;
        //sessionStorage.setItem('CurrentCompanyId', sessionStorage.getItem('LoggedInCompanyId') );
        
        sessionStorage.setItem('CurrentDivisionId', parseInt(id)); 
        sessionStorage.setItem('LoggedInDivisionId', parseInt(id)); 
        sessionStorage.setItem('LoggedInDivisionShortName', division.division_short_name); 
        sessionStorage.setItem('LoggedInDivisionCode', division.division_code); 
        sessionStorage.setItem('LoggedInDivisionName', division.division_name); 
        
        sessionStorage.setItem('CurrentDivisionName', division_name); // Store the selected company name
        setSelectedDivisionId(id);
        setSelectedDivision(division_name); // Update state
        fetchCurrentDivisionList(); 
        
        if(sessionStorage.getItem('LoggedInDepartmentId')==0){ 
            sessionStorage.setItem('LoggedInDepartmentId', '0');
            sessionStorage.setItem('CurrentDepartmentId', '0');
            setSelectedDepartment(' All Department');
            sessionStorage.setItem('CurrentDepartmentName', '');
            fetchCurrentDepartmentList();
        }
        sessionStorage.setItem('applyDivisionFilter', 'Yes');
        //window.location.reload(false);
    };
    /* ── fetch list ── */
    const fetchCurrentCompanyList = useCallback(async () => {
        try{ setFilterLoading(true);
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data':{
                                'company_id':sessionStorage.getItem('LoggedInCompanyId'),
                                'division_id':sessionStorage.getItem('LoggedInDivisionId'),
                                'department_id':sessionStorage.getItem('LoggedInDepartmentId'),
                                'curr_company_id':sessionStorage.getItem('CurrentCompanyId'),
                                'curr_division_id':sessionStorage.getItem('CurrentDivisionId'),
                                'curr_department_id':sessionStorage.getItem('CurrentDepartmentId')
                            },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token':EncryptData }
            
            getCompanyProfileDDList(oData).then(res => {
                //console.log('oData-CurrentCompanyId');
                //console.log(res.data.oResult);
                if (res?.data?.oResult?.data?.length) setCompanies(res.data.oResult.data);
                //console.log(res.data);
                if(res?.data?.oResult?.curr_token && sessionStorage.getItem('CurrentCompanyId')>=0){
                    sessionStorage.setItem('LoggedInToken',res.data.oResult.curr_token);
                    //sessionStorage.setItem('CurrentCompanyId',false);
                    //console.log('company-LoggedInToken');
                    //console.log(res.data.oResult.curr_token);
                }
            }).catch(() => {})
            .finally(() => setFilterLoading(false));
            
        } catch (error) {
            console.error('Error fetching Company Profile:', error);
            }
        }, []);
    const fetchCurrentDivisionList = useCallback(async () => {
    try{ setFilterLoading(true);
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data':{
                    'company_id':sessionStorage.getItem('LoggedInCompanyId'),
                    'division_id':sessionStorage.getItem('LoggedInDivisionId'),
                    'other_division_ids':sessionStorage.getItem('LoggedInOtherDivisionIds'),
                    'department_id':sessionStorage.getItem('LoggedInDepartmentId'),
                    'curr_company_id':sessionStorage.getItem('CurrentCompanyId'),
                    'curr_division_id':sessionStorage.getItem('CurrentDivisionId'),
                    'curr_department_id':sessionStorage.getItem('CurrentDepartmentId')
                },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token':EncryptData }
            if(sessionStorage.getItem('LoggedInOtherDivisionIds')==null || sessionStorage.getItem('LoggedInOtherDivisionIds')==''){
                getDivisionDDList(oData).then(res=>{
                    if(res?.data?.data?.length){ 
                        setDivisions(res.data.data);
                        if(res?.data?.curr_token && sessionStorage.getItem('CurrentDivisionId')>= 0 ){
                            sessionStorage.setItem('LoggedInToken',res.data.curr_token);
                        }
                    } 
                }).catch(() => {})
                .finally(() => setFilterLoading(false));
            }else{
                getDivisionAdditionalList(oData).then(res=>{
                    if(res?.data?.data?.length){ 
                    setOtherDivisions(res.data.data);
                    } 
                }).catch(() => {})
                .finally(() => setFilterLoading(false));
            }
        } catch (error) {
            console.error('Error fetching Current Division List:', error);
        }
    }, []);
    const fetchCurrentDepartmentList = useCallback(async () => {
        try{ setFilterLoading(true);
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {
                    'company_id':sessionStorage.getItem('LoggedInCompanyId'),
                    'division_id':sessionStorage.getItem('LoggedInDivisionId'),
                    'department_id':sessionStorage.getItem('LoggedInDepartmentId'),
                    'curr_company_id':sessionStorage.getItem('CurrentCompanyId'),
                    'curr_division_id':sessionStorage.getItem('CurrentDivisionId'),
                    'curr_department_id':sessionStorage.getItem('CurrentDepartmentId')
                },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            
            let oData = { 'token':EncryptData }

            getDepartmentDDList(oData).then(res => {
                if (res?.data?.oResult?.data?.length) setDepartments(res.data.oResult.data);
                //console.log('oData-Departments');
                //console.log(res.data.oResult);
                if(res?.data?.oResult?.curr_token && sessionStorage.getItem('CurrentDepartmentId')>=0){
                    sessionStorage.setItem('LoggedInToken',res.data.oResult.curr_token);
                    //sessionStorage.setItem('CurrentDepartmentId',false);
                    
                }
            }).catch(() => {})
            .finally(() => setFilterLoading(false));
        } catch (error) {
            console.error('Error fetching department:', error);
        }
    }, []);

    useEffect(() => {
        fetchCurrentCompanyList();
        fetchCurrentDivisionList();
        fetchCurrentDepartmentList();
        
    }, [fetchCurrentCompanyList,fetchCurrentDivisionList,fetchCurrentDepartmentList]);

    /* ── close on outside click ── */
    useEffect(() => {
        const handleOutside = (e) => {
            if (
                filteropen &&
                panelFilRef.current &&
                !panelFilRef.current.contains(e.target) &&
                filterRef.current &&
                !filterRef.current.contains(e.target)
            ) {
                setFilterOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, [filteropen]);

    /* ── dismiss all ── */
    const handleClearFilter = () => {
        
        if(sessionStorage.getItem('applyCompanyFilter')=="Yes"){
            sessionStorage.setItem('CurrentCompanyId', '0');
            sessionStorage.getItem('LoggedInCompanyId', '0');
            sessionStorage.setItem('CurrentCompanyName', ''); 
            setSelectedCompany(' Select Company'); // Update state
            sessionStorage.setItem('applyCompanyFilter', 'no');
            fetchCurrentCompanyList();
        } 
        if(sessionStorage.getItem('applyDivisionFilter')=="Yes"){
            sessionStorage.setItem('LoggedInDivisionId', '0');
            sessionStorage.setItem('CurrentDivisionId', '0');
            sessionStorage.setItem('CurrentDivisionName', '');
            setSelectedDivision(' Select Branch');
            sessionStorage.setItem('applyDivisionFilter', 'no');
            fetchCurrentDivisionList();
        }
        if(sessionStorage.getItem('applyDepartmentFilter')=="Yes"){
            sessionStorage.setItem('LoggedInDepartmentId', '0');
            sessionStorage.setItem('CurrentDepartmentId', '0');
            sessionStorage.setItem('CurrentDepartmentName', '');
            setSelectedDepartment(' Select Department');
            sessionStorage.setItem('applyDepartmentFilter', 'no');
            fetchCurrentDepartmentList();
        }
        window.location.reload(false); 
    };
    const handleFilter = () => {
        //sessionStorage.setItem('applyFilter', 'yes');
        window.location.reload(false);
    };
    
    return (
        <div className="nbell-wrapper" id="nbell-wrapper">
            {/* ── Filter ── */}
            
            <button
                ref={filterRef}
                className={`nbell-btn dropdown-toggle${filteropen ? ' nbell-btn--active dropdown-toggle' : ''}`}
                onClick={() => setFilterOpen((v) => !v)}
                aria-label="Filters"
                type="button"
            >
                <img className="img_sidebar_icon" src={process.env.REACT_APP_BASE_URL+"/icon/filter.png"}/>
                
            </button>

            {/* ── Notification Panel ── */}
            {filteropen && (
                <div
                    ref={panelFilRef}
                    id="nbell-panel"
                    className="nbell-panel"
                    role="dialog"
                    aria-label="Filter panel"
                >
                    {/* Panel Header */}
                    <div className="nbell-panel-header" id="nbell-panel-header">
                        <h3 className="nbell-panel-title" id="nbell-panel-title">
                            Filters
                        </h3>
                        <button
                            id="nbell-close-btn"
                            className="nbell-close-btn"
                            onClick={() => setFilterOpen(false)}
                            aria-label="Close filter"
                            type="button"
                        >
                            <i className="bi bi-x-lg"></i>
                        </button>
                    </div>
                    {/* Notification Body */}
                    <div className="nbell-panel-body" id="nbell-panel-body">
                                {(sessionStorage.getItem("LoggedInCompanyId") == 0 || sessionStorage.getItem('CurrentCompanyId')> 0 ) ?(
                                <div className="filter-group" id="filter-group-1">
                                <span><strong>Company: </strong></span>
                                <div className="filter-group" id="filter-group-2">
                                        <span><span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="primary" id="profile-dropdown">
                                                    <i className="bi bi-diagram-2-fill"></i>{selectedCompany}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {/* Search input */}
                                                    <input type="text" className='form-control' placeholder="Search company..." onChange={handleSearchCompany} />
                                                    <Dropdown.Item key={0}  
                                                            active={parseInt(0) === parseInt(sessionStorage.getItem("CurrentCompanyId"))}
                                                            onClick={() => handleSelectCompany({'company_id':0,'company_name':'All Company'})}>All Company
                                                        </Dropdown.Item>
                                                    {/* Filtered list of companies based on search term */}
                                                    {companies && companies.length > 0 ? (
                                                        <>
                                                        { companies.filter(com_option => com_option.company_name.toLowerCase().includes(searchCompany.toLowerCase()))
                                                        .map((com_option) => (
                                                            <Dropdown.Item 
                                                                key={com_option.company_id} 
                                                                active={parseInt(com_option.company_id) === parseInt(sessionStorage.getItem("CurrentCompanyId"))}
                                                                onClick={() => handleSelectCompany(com_option)}>{com_option.company_name}
                                                                
                                                            </Dropdown.Item>
                                                            ))
                                                        }
                                                    </>
                                                        ) : (
                                                            <Dropdown.Item disabled>No Data</Dropdown.Item>
                                                        )
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </span>  </span>
                                        </div>
                                </div>):(<span>{ /*sessionStorage.getItem("LoggedInCompanyName")*/ }</span>)}
                                
                                <div className="filter-group" id="filter-group-3">
                                        <span><strong>Department: </strong>{(sessionStorage.getItem("LoggedInDepartmentId")==0 || sessionStorage.getItem('CurrentDepartmentId')> 0)?(<span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="primary" id="department-dropdown">
                                                <i className="bi bi-diagram-2-fill"></i>{selectedDepartment}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                {/* Search input */}
                                                <input type="text" className='form-control' placeholder="Search Department..." onChange={handleSearchDepartment} />
                                                
                                                {departments && departments.length > 0 ? (
                                                    <><Dropdown.Item key={0}  
                                                    active={parseInt(0) === parseInt(sessionStorage.getItem("CurrentDepartmentId"))}
                                                    onClick={() => handleSelectDepartment({'id':'0','department_name':'All Department'})}>
                                                    All Department
                                                </Dropdown.Item>
                                                    { departments.filter(dep_option => dep_option.department_name.toLowerCase().includes(searchDepartment.toLowerCase()))
                                                            .map((dep_option) => (
                                                    <Dropdown.Item key={dep_option.id} 
                                                        active={parseInt(dep_option.id) === parseInt(sessionStorage.getItem("CurrentDepartmentId"))}
                                                        onClick={() => handleSelectDepartment(dep_option)}>{dep_option.department_name}
                                                        </Dropdown.Item>
                                                    ))
                                                    }</> 
                                                ) : (
                                                    <option value="">No Data</option>
                                                )}</Dropdown.Menu>
                                            </Dropdown>
                                        </span>):(<span>{ sessionStorage.getItem("LoggedInDepartmentName")}</span>)}  </span>
                                        </div>
                                
                                
                                <div className="filter-group" id="filter-group-4">
                                        <span><strong>Branch: </strong>

                                        {(sessionStorage.getItem("LoggedInOtherDivisionIds") && sessionStorage.getItem("LoggedInOtherDivisionIds").trim() !== "") ? (<span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="primary" id="branch-dropdown">
                                                <i className="bi bi-diagram-2-fill"></i>{selectedDivision}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                {/* Search input */}
                                                <input type="text" className='form-control' placeholder="Search Branch..." onChange={handleSearchDivision} />
                                                
                                                {otherDivisions && otherDivisions.length > 0 ? (
                                                    <>
                                                    { otherDivisions.filter(br_option => br_option.division_name.toLowerCase().includes(searchDivision.toLowerCase()))
                                                        .map((br_option) => (
                                                        <Dropdown.Item key={br_option.id} 
                                                        active={parseInt(br_option.id) === parseInt(sessionStorage.getItem("CurrentDivisionId"))}
                                                        onClick={() => handleSelectDivision(br_option)}>{br_option.division_name}    
                                                        
                                                        </Dropdown.Item>
                                                        ) ) 
                                                    }</>
                                                ) : (
                                                    <option value="">No Data</option>
                                                )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </span> ):(
                                        (sessionStorage.getItem("LoggedInDivisionId")==0 || sessionStorage.getItem('CurrentDivisionId')> 0)?(<span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="primary" id="branch-dropdown">
                                                <i className="bi bi-diagram-2-fill"></i>{selectedDivision}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                {/* Search input */}
                                                <input type="text" className='form-control' placeholder="Search Branch..." onChange={handleSearchDivision} />
                                                
                                                {divisions && divisions.length > 0 ? (
                                                    <><Dropdown.Item key={0} 
                                                    active={parseInt(0) === parseInt(sessionStorage.getItem("CurrentDivisionId"))}
                                                    onClick={() => handleSelectDivision({'id':'0','division_name':'All Branch'})}>
                                                        All Branch
                                                    </Dropdown.Item>
                                                    { divisions.filter(br_option => br_option.division_name.toLowerCase().includes(searchDivision.toLowerCase()))
                                                        .map((br_option) => (
                                                        <Dropdown.Item key={br_option.id} 
                                                        active={parseInt(br_option.id) === parseInt(sessionStorage.getItem("CurrentDivisionId"))}
                                                        onClick={() => handleSelectDivision(br_option)}>{br_option.division_name}    
                                                        
                                                        </Dropdown.Item>
                                                        ) ) 
                                                    }</>
                                                ) : (
                                                    <option value="">No Data</option>
                                                )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </span>):(<span>{sessionStorage.getItem("LoggedInDivisionName")}</span>))}  </span>
                                        </div>
                    </div>
                

                    {/* Footer: View All */}
                    <div className="nbell-footer" id="nbell-footer">
                        <button className='al-btn al-btn-outline btn-sm' onClick={() => handleFilter()}>Apply Filter</button>
                    </div>
                    
                </div>

            )}
        </div>
    );
}

export default CompDivDepFilter;